import DOMPurify from "dompurify";

/**
 * Sanitizes HTML content to prevent XSS attacks
 * while safely allowing trusted iframe embeds
 * (e.g. Facebook Ad previews)
 *
 * @param html - Raw HTML string
 * @returns Sanitized HTML safe for rendering
 */
export const sanitizeHtml = (html: string): string => {
    return DOMPurify.sanitize(html, {
        // Allow only required tags
        ALLOWED_TAGS: [
            "b",
            "i",
            "em",
            "strong",
            "a",
            "p",
            "br",
            "ul",
            "ol",
            "li",
            "span",
            "div",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "iframe",
        ],

        // Allow only safe attributes
        ALLOWED_ATTR: [
            "href",
            "target",
            "rel",
            "class",
            "id",
            "src",
            "width",
            "height",
            "frameborder",
            "allow",
            "allowfullscreen",
            "scrolling",
            "style",
        ],

        // Prevent javascript: URLs etc.
        ALLOW_DATA_ATTR: false,

        // Extra safety for links
        FORBID_ATTR: ["onerror", "onload", "onclick"],

        // Optional: lock iframe sources if needed
        // You can uncomment this if you want ONLY Facebook previews
        /*
        ALLOWED_URI_REGEXP:
          /^(https?:)?\/\/(www\.)?(facebook\.com|business\.facebook\.com)\//,
        */
    });
};
